// UploadPhoto returns a filename stored under wwwroot/uploads.
export function uploadAssetUrl(value, base) {
  const path = String(value || "").trim();
  const configured = new URL(base);
  if (configured.pathname === "/") configured.pathname = "/uploads/";
  if (!configured.pathname.endsWith("/")) configured.pathname += "/";
  if (/^https?:\/\//i.test(path)) return repairUploadUrl(path, configured.href);
  return new URL(path.replace(/^\/?uploads\//i, "").replace(/^\//, ""), configured).href;
}

// Only repair root-level generated image names on our API, never external URLs.
export function repairUploadUrl(value, base = "https://api.infinityapply.com/uploads/") {
  try {
    const url = new URL(value);
    const configured = new URL(base);
    if ((url.origin === configured.origin || url.hostname === "api.infinityapply.com") &&
        /^\/[a-f0-9]{32}\.(jpe?g|png|webp|gif)$/i.test(url.pathname)) {
      url.pathname = `/uploads${url.pathname}`;
      return url.href;
    }
  } catch { /* Relative content URLs are left unchanged. */ }
  return value;
}
